<template>
  <Modal
    v-model:visible="isVisible"
    class="bulk-tender-results-modal"
    :header="t('shipments.bulkTenderResults')"
    size="md"
    maximizable
    @keyup.esc="isVisible = false"
  >
    <ul class="bulk-tender-results-modal-body">
      <BulkTenderResultCard
        v-for="result in sortedResults"
        :key="result.shipmentId"
        :result="result"
      />
    </ul>

    <template #footer>
      <RygenButton
        mode="primary"
        :label="t('common.close')"
        @click="isVisible = false"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { BulkTenderResult } from '@/model';

import BulkTenderResultCard from '@/components/shipment/BulkTenderResultCard.vue';
import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  results: {
    type: Array as PropType<BulkTenderResult[]>,
    default: () => [],
  },
});

const { results } = toRefs(props);

const sortedResults = computed(() => {
  return [...results.value].sort((a, b) => {
    const scacA = a.request?.carrier?.scac || '';
    const scacB = b.request?.carrier?.scac || '';
    return scacA.localeCompare(scacB);
  });
});

const { t } = useI18n();
</script>

<style>
.bulk-tender-results-modal.rygen-modal.p-dialog {
  border: 0;

  .p-dialog-content {
    display: flex;
    flex-flow: column;
    min-height: 0;
    padding: 0;

    .bulk-tender-results-modal-body {
      padding: var(--sp-6) var(--sp-12);
      flex: 1 1 auto;
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      grid-auto-rows: min-content;
      gap: var(--sp-3);
      overflow: auto;

      .p-card {
        height: min-content;
      }
    }
  }
}
</style>
